import Breadcrumb from '@carvana/ds-breadcrumb';
import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { createComponent } from '@carvana/merch-components';
import { useCallback, useContext, useMemo } from 'react';
import SEOContext from '~/context/srp/SEOContext';

const Wrapper = createComponent('div', {
  className:
    'border-b border-t border-solid border-border-subtle bg-background-default px-2xl py-xl sm:px-3xl md:px-4xl md:py-2xl'
});

export default function Breadcrumbs() {
  const { vanityUrl } = useContext(SEOContext);
  const { trackEvent } = useContext(AnalyticsContext);

  const handleClick = useCallback(
    (description: string, text: string) => {
      trackEvent('Breadcrumbs', { action: 'clicked', description, text });
    },
    [trackEvent]
  );

  const breadCrumbs = useMemo(() => {
    if (!vanityUrl?.keyword) return null;

    return [
      {
        href: '/cars',
        key: 'all-cars',
        label: 'Used Cars',
        onClick: () => handleClick('all', 'Used Cars')
      },
      {
        href: vanityUrl.path,
        key: 'vanity-keyword',
        label: vanityUrl.keyword,
        onClick: () => handleClick('vanityKeyword', vanityUrl.keyword)
      }
    ];
  }, [handleClick, vanityUrl?.keyword, vanityUrl?.path]);

  return breadCrumbs ? (
    <Wrapper>
      <Breadcrumb
        backIcon={false}
        className="whitespace-pre"
        crumbs={breadCrumbs}
        size="sm"
      />
    </Wrapper>
  ) : null;
}
